import { Doughnut } from 'vue-chartjs'
import chart from '@/mixins/chart'
import Colors from '@/utils/chart-options/colors'
import options from '@/utils/chart-options/doughnutsChart'

export default {
  extends: Doughnut,
  mixins: [chart],
  props: {
    options: {
      type: Object,
      default: () => options
    }
  },
  methods: {
    datasetToChartData (dataset) {
      const percent = parseInt(dataset.rows[0][0])
      const total = parseInt(dataset.rows[0][1])
      const newUser = Math.round(total * percent / 100)

      return {
        labels: [this.$t('charts.newvsreturning.returning'), this.$t('charts.newvsreturning.new')],
        datasets: [
          {
            label: this.$t('charts.newvsreturning.title'),
            data: [
              total - newUser,
              newUser
            ],
            backgroundColor: dataset.rows[0].map((e, i) => Colors[i](this)),
            hoverBackgroundColor: dataset.rows[0].map((e, i) => Colors[i](this))
          }
        ]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/charts/newVsReturning.js